export default "__VITE_ASSET__Bvi6FL$h__"